<template>
  <div class="app-container w-screen min-w-[300px]">
    <!-- Background overlay for smooth transitions -->
    <div class="background-transition" :class="{ 'login-bg': currentRoute.path.includes('login') }"></div>

    <!-- Loading overlay -->
    <LoadingOverlay/>

    <!-- Router View sẽ hiển thị component tương ứng với route hiện tại -->
    <router-view v-slot="{ Component, route }">
      <transition
          :name="route.path.includes('login') ? 'login-transition' : 'page-transition'"
          :duration="500">
        <div class="page-container w-screen h-screen min-w-[300px]">
          <!-- Header component only shown for routes requiring authentication -->
          <Header v-if="currentRoute.meta.isShowHeader"/>
          <div
              class="relative float-end z-[1] w-full h-screen pt-16 md:pt-20">
            <component :is="Component"/>
          </div>
        </div>
      </transition>
    </router-view>
  </div>

  <!--  <Footer v-if="currentRoute.meta.requiresAuth"/>-->
</template>

<script setup lang="ts">
import {useRoute} from 'vue-router';
import Header from '@/components/layout/Header.vue';
import {usePageAutoReload} from './composables/usePageAutoReload';
import LoadingOverlay from '@/components/LoadingOverlay.vue';

usePageAutoReload(5 * 60 * 1000) // 5 phút

// import Footer from '@/components/layout/Footer.vue';

document.body.style.userSelect = "none";
const currentRoute = useRoute();
</script>

<style>
/* App container and background */
.app-container {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
}

.background-transition {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background: var(--background);
  transition: all 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}

.login-bg {
  background: linear-gradient(135deg, var(--background), color-mix(in srgb, var(--primary) 10%, var(--background)));
}

/* Standard page transitions */
.page-transition-enter-active,
.page-transition-leave-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
}

.page-transition-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.page-transition-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* Login/logout specific transitions */
.login-transition-enter-active,
.login-transition-leave-active {
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: opacity, transform;
}

.login-transition-enter-from {
  opacity: 0;
  transform: scale(0.95) translateY(30px);
}

.login-transition-leave-to {
  opacity: 0;
  transform: scale(1.05) translateY(-30px);
}
</style>
